import React, { useState, useRef, useEffect, useCallback, useImperativeHandle, forwardRef } from "react";
import * as XLSX from "xlsx";
import { Trash2 } from "lucide-react";
import axios from "axios";
import Modal from "../../common/CommonModal";
import useApi from "../../../hooks/useApi";
import ProductListing from "../../salesInvoice/ProductsModal";

const BillOfMaterialsTable = forwardRef((props , ref) => {

  const {
  isEdit,
  formData,
  setFormData,
  bomEntries,
  setBomEntries,
  onBomEntriesChange,
  onEntriesChange,
} = props;

   useImperativeHandle(ref, () => ({
    resetEntriesBOMTable() {
      resetEntries()
      console.log("BOM reset from table done!");
    },
  }));



  console.log("Bill of materials Table isEdit:", isEdit);
  // console.log('Bill of materials Table formdata.code:',formData.code)
  const [selectAll, setSelectAll] = useState(false);
  const [entries, setEntries] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [codeModalOpen, setCodeModalOpen] = useState(false);
  const [activeRowIndex, setActiveRowIndex] = useState(null);
  const fileInputRef = useRef(null);

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchBy, setSearchBy] = useState("UNIVERSAL");
  const { request } = useApi();
  const COMPANY_CODE = localStorage.getItem("companyCode");
  const API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";
  const BASE_URL = API_PATHS[0]?.API_CONFIG;

  const CmpCode = COMPANY_CODE;
  const mode = "ENTRY";
  const parentCode = formData.code; // Your BOM parent code

  // Load BOM data initially
  useEffect(() => {
    if (isEdit && formData.code && formData.code.length > 0) {
      fetchBOMData();
    }
  }, [isEdit, formData.code]);
  // Keep parent updated when entries change
  // useEffect(() => {
  //   onEntriesChange(entries);
  // }, [entries, onEntriesChange]);

  const fetchBOMData = async () => {
    try {
      let company_code_from_local_storage = localStorage.getItem("companyCode")
        ? localStorage.getItem("companyCode")
        : "-";
      let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

      const apiBaseURL = apiPaths_from_local_storage[0]?.API_CONFIG;
      const response = await axios.get(
        // `${apiBaseURL}/api/CpaysCount/${company_code_from_local_storage}/BOM/1000452582MRAL7035/-`
        `${apiBaseURL}/api/CpaysCount/${company_code_from_local_storage}/BOM/${formData.code}/-`,
      );
      console.log("response.data Retrieval of BOM:", response.data);
      setEntries(
        response.data.map((item) => ({
          ...item,
          selected: false,
        })),
      );
    } catch (error) {
      console.error("Error fetching BOM data!");
    }
  };

  const toggleSelectAll = (checked) => {
    setSelectAll(checked);
    setEntries((prev) => prev.map((r) => ({ ...r, selected: checked })));
  };

  const toggleRow = (idx, checked) => {
    setEntries((prev) => {
      const updated = [...prev];
      updated[idx].selected = checked;
      return updated;
    });
  };

  const updateCell = (idx, field, value) => {
    setEntries((prev) => {
      const updated = [...prev];
      updated[idx][field] = value;
      return updated;
    });
  };

  const addRow = () => {
    setEntries((prev) => [
      ...prev,
      {
        c_code: "",
        c_description: "",
        unit: "",
        Qty: "",
        selected: false,
      },
    ]);
  };

  const deleteSelected = () => {
    setEntries((prev) => prev.filter((r) => !r.selected));
  };

  const resetEntries = () => {
    setEntries([]);
  };

  const handleImport = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      const wb = XLSX.read(evt.target.result, { type: "binary" });
      const ws = wb.Sheets[wb.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(ws, { header: 1 });

      const imported = rows.slice(1).map((r) => ({
        c_code: r[0] ?? "",
        c_description: r[1] ?? "",
        unit: r[2] ?? "",
        Qty: r[3] ?? "",
        selected: false,
      }));

      setEntries((prev) => [...prev, ...imported]);
    };
    reader.readAsBinaryString(file);

    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const saveBOM = async () => {
    try {
      let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

      const apiBaseURL = apiPaths_from_local_storage[0]?.API_CONFIG;
      setIsSaving(true);

      // Create payload
      const payload = entries
        .filter((r) => r.c_code.trim() !== "") // ignore empty rows
        .map((r) => ({
          CmpCode: CmpCode,
          mode: mode,
          code: parentCode,
          c_code: r.c_code,
          c_description: r.c_description,
          unit: r.unit,
          qty: r.Qty,
        }));

      if (payload.length === 0) {
        alert("No valid rows to save.");
        setIsSaving(false);
        return;
      }

      await axios.post(`${apiBaseURL}/api/CRMBOM`, payload);

      alert("BOM saved successfully!");
      fetchBOMData();
    } catch (error) {
      console.error("Error saving BOM:", error);
      alert("Error saving BOM data.");
    } finally {
      setIsSaving(false);
    }
  };

  const fetchProductData = useCallback(
    async (query, searchByValue, location = "A") => {
      // Convert empty string to "-"
      const effectiveQuery = query?.trim() === "" ? "-" : query?.trim() || "-";
      const formattedQuery = effectiveQuery.replace(/\//g, "%2F");

      try {
        setLoading(true);
        const url = `${BASE_URL}/api/CRMStockList/${COMPANY_CODE}/${searchByValue}/${formattedQuery}/${location}/-`;
        const response = await request({
          url: url,
          method: "GET",
          timeout: 5000,
        });
        if (response) {
          setProducts(response);
        } else {
          setProducts([]);
        }
      } catch (err) {
        console.error("Failed to fetch product data", err);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    },
    [BASE_URL, COMPANY_CODE, request],
  );
  useEffect(() => {
    fetchProductData(searchQuery, searchBy);
  }, [searchQuery, searchBy]);

  const handleProductSelect = (product) => {
    console.log("Selected Product:", product);
    if (activeRowIndex === null) return;

    setEntries((prev) => {
      const updated = [...prev];
      updated[activeRowIndex] = {
        ...updated[activeRowIndex],
        c_code: product.id || "",
        c_description: product.Description || "",
        unit: product.Unit || "",
        // Qty: product.QTY || updated[activeRowIndex].Qty || "",
      };
      return updated;
    });

    setCodeModalOpen(false);
    setActiveRowIndex(null);
  };

  useEffect(() => {
    if (onBomEntriesChange) {
      onBomEntriesChange(entries);
    }
  }, [entries]);

  useEffect(() => {
    if (onEntriesChange) {
      onEntriesChange(entries);
    }
  }, [entries]);

  return (
    <div className="mt-6">
      <div className="h-[400px] bg-white overflow-auto border rounded-md ">
        <table className="text-sm w-full bg-white">
          <thead className="bg-gray-100 sticky top-0 z-20">
            <tr className="h-10">
              <th className="border px-2 text-center shadow-none">
                <input
                  type="checkbox"
                  checked={selectAll}
                  onChange={(e) => toggleSelectAll(e.target.checked)}
                  className="w-5 h-5 cursor-pointer"
                />
              </th>
              <th className="border px-2 font-normal shadow-none">Code</th>
              <th className="border px-2 font-normal shadow-none">
                Description
              </th>
              <th className="border px-2 font-normal shadow-none">Unit</th>
              <th className="border px-2 font-normal shadow-none">Qty</th>
            </tr>
          </thead>

          {/* <tbody className="divide-y divide-gray-200"> */}
          <tbody>
            {entries.length === 0 ? (
              <tr>
                <td colSpan={8} className="text-center py-8 text-gray-500">
                  No Bill of Materials Data Added!
                </td>
              </tr>
            ) : (
              entries.map((row, idx) => (
                <tr key={idx} className="border">
                  <td className="border px-2 text-center">
                    <input
                      type="checkbox"
                      checked={row.selected}
                      onChange={(e) => toggleRow(idx, e.target.checked)}
                      className="w-4 h-4 cursor-pointer"
                    />
                  </td>

                  <td className="border p-1">
                    <input
                      onKeyDown={(e) => {
                        if (e.key === "F2") {
                          e.preventDefault();
                          e.stopPropagation();
                          setActiveRowIndex(idx);
                          setCodeModalOpen(true);
                        }
                      }}
                      placeholder="Enter or press F2 to select Item"
                      value={row.c_code}
                      onChange={(e) =>
                        updateCell(idx, "c_code", e.target.value)
                      }
                      className="w-full px-2 text-sm border-none focus:ring-1 rounded"
                    />
                  </td>

                  <td className="border p-1">
                    <input
                      value={row.c_description}
                      onChange={(e) =>
                        updateCell(idx, "c_description", e.target.value)
                      }
                      className="w-full px-2 text-sm border-none focus:ring-1 rounded"
                    />
                  </td>

                  <td className="border p-1">
                    <input
                      value={row.unit}
                      onChange={(e) => updateCell(idx, "unit", e.target.value)}
                      className="w-full px-2 text-sm border-none focus:ring-1 rounded "
                    />
                  </td>

                  <td className="border p-1">
                    <input
                      value={row.Qty}
                      onChange={(e) => updateCell(idx, "Qty", e.target.value)}
                      className="w-full px-2 text-sm border-none text-right focus:ring-1 rounded"
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Actions */}
      <div className="flex justify-between items-center mt-4">
        <button
          onClick={addRow}
          className="px-2 py-1 bg-blue-600 text-white text-sm rounded hover:bg-blue-700"
        >
          + Add
        </button>

        {entries.some((r) => r.selected) && (
          <button
            onClick={deleteSelected}
            className="px-2 py-1 bg-red-600 text-white text-sm rounded hover:bg-red-700 flex items-center"
          >
            <Trash2 className="w-3 h-4 mr-2" />
            Delete
          </button>
        )}
        {/* <button
          onClick={resetEntries}
          className="px-2 py-1 bg-gray-600 text-white text-sm rounded hover:bg-gray-700 flex items-center"
        >
          Reset Entries From Child
        </button> */}

        <label className="cursor-pointer">
          <input
            ref={fileInputRef}
            type="file"
            accept=".xlsx,.xls"
            onChange={handleImport}
            className="hidden"
          />
          <span className="px-2 py-1 bg-green-600 text-white text-sm rounded hover:bg-green-700 inline-block">
            Import
          </span>
        </label>

        {/* <button
          onClick={saveBOM}
          disabled={isSaving}
          className="px-4 py-1 bg-purple-600 text-white text-sm rounded hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isSaving ? "Saving..." : "Save BOM"}
        </button> */}
      </div>
      {codeModalOpen && (
        <Modal
          isOpen={codeModalOpen}
          onClose={() => setCodeModalOpen(false)}
          title={"Select Item Code"}
          size="xxl"
          header={true}
        >
          <ProductListing
            modalSuggestions={products}
            loading={loading}
            searchBy={searchBy}
            setSearchBy={setSearchBy}
            onSearchQueryChange={setSearchQuery}
            handleProductSelect={handleProductSelect}
          />
        </Modal>
      )}
    </div>
  );
});

export default BillOfMaterialsTable;
